var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('Hero',{attrs:{"heading":_vm.$t('thankYou'),"subheading":true},scopedSlots:_vm._u([{key:"subheading",fn:function(){return [_vm._v(_vm._s(_vm.$t('informationRecieved')))]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }